// Components
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'

// Utils
import { placeholderBlurhash } from '@/lib/utils'
import Image from 'next/image'

export function GalleryModal({
  images,
  title,
  description,
  modalOpen,
  setModalOpen,
  initialIndex, // new prop
}: {
  images: (string | null)[]
  title: string
  description: string
  modalOpen: boolean
  setModalOpen: () => void
  initialIndex: number
}) {
  return (
    <Dialog
      open={modalOpen}
      onOpenChange={(open) => {
        if (!open) {
          setModalOpen()
        }
      }}
    >
      <DialogContent
        overlayClassName="bg-black/95 !backdrop-blur-none"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
        className="max-w-[95vw] sm:max-w-7xl w-full p-2 md:p-6 border-none bg-transparent shadow-none focus:outline-none flex flex-col justify-center text-white"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">
          {title} Gallery
        </DialogDescription>
        <Carousel
          className="w-full relative"
          opts={{ startIndex: initialIndex }}
        >
          <CarouselContent className="-ml-0">
            {images &&
              images.map((image, index) => (
                <CarouselItem
                  key={index}
                  className="p-0 flex items-center justify-center"
                >
                  <div
                    className="relative w-full h-[60vh] lg:h-[85vh] flex items-center justify-center cursor-zoom-out"
                    onClick={() => setModalOpen()}
                  >
                    {/* Using native img here allows the bounding box to shrink-wrap to the image's actual aspect ratio.
                        This way, clicking the empty space hits the parent div and closes the modal. */}
                    <img
                      src={image || ''}
                      className="max-w-full max-h-full object-contain cursor-default"
                      alt={`${title} - Image ${index + 1}`}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </CarouselItem>
              ))}
          </CarouselContent>
          <CarouselPrevious className="left-2 md:left-4 2xl:-left-14 bg-white/50 text-black hover:bg-white/60  border-none z-50 h-12 w-12" />
          <CarouselNext className="right-2 md:right-4 2xl:-right-14 bg-white/50 text-black hover:bg-white/60  border-none z-50 h-12 w-12" />
        </Carousel>
      </DialogContent>
    </Dialog>
  )
}
